import {MatPaginatorOptions} from '@gits/ngx-tabulator-tables/lib/models/pagination-config.model';

export const PAGINATION_OPTIONS: MatPaginatorOptions = {
  pageSize: 50,
  pageSizeOptions: [5, 10, 25, 50, 100]
}
